import { IActionParams } from './action';

export interface IUseStateReducer<T> {
    (state: T, action: IActionParams<T>): T;
}

export function useStateReducer<T>(state: T, action: IActionParams<T>): T {
    const { type, value } = action;
    state = {
        ...state,
        [type]: value,
    }
    return state;
}